export default class User {
    constructor(username, password, role) {
        this.username = username;
        this.password = password;
        this.role = role
    }
}